import React from "react";
import { useSelector } from "react-redux";
import OutputColumnForms from "./OutputColumnForms";
import { ReadFile } from "./ReadFile";
import Configure from "./Configure";
import InputColumnForm from "./InputColumnForm";
import SaveRules from "./SaveRules";
import Notes from "./Notes";

const WorkSpace = () => {
  const currentComponent = useSelector(
    (state) => state.workspace.currentComponent,
  );

  return (
    <div className="flex flex-col sm:flex-row items-center sm:items-start w-full h-full  justify-center py-2">
      {/* {currentComponent === "" && <InputColumnForm />} */}
      {currentComponent === "inputColumnForm" && <InputColumnForm />}
      {currentComponent === "outputColumnForm" && <OutputColumnForms />}
      {currentComponent === "ReadFile" && <ReadFile />}
      {currentComponent === "Configure" && <Configure />}
      {currentComponent === "SaveRules" && <SaveRules />}
      {currentComponent === "notes" && <Notes />}
      {/* Fallback condition */}
      {![
        "inputColumnForm",
        "outputColumnForm",
        "ReadFile",
        "Configure",
        "SaveRules",
        "notes",
      ].includes(currentComponent) && (
        <div className=" w-full lg:text-lg bg-gray-200 text-center p-4">
          Select action from the menu to start creating your workspace.
        </div>
      )}
    </div>
  );
};

export default WorkSpace;
